'use client';

import styled from 'styled-components';

import { breakpoints, colors } from '@/styles/theme';

export const HeaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  display: flex;
  flex-direction: column;
  align-items: center;

  transition: transform 0.3s ease;
  transform: translateY(${({ $isVisible }) => ($isVisible ? '0' : '-100%')});

  z-index: 99;
`;

export const Container = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  max-width: 1720px;
  padding: 8px 16px;

  background-color: ${colors.gray0};

  @media (max-width: ${breakpoints.laptop}) {
    padding: 8px 16px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    padding: 8px 16px;
  }
`;

export const Section = styled.div`
  display: flex;
  align-items: center;

  gap: 20px;

  @media (max-width: ${breakpoints.laptop}) {
    display: none;
  }
`;

export const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;

  width: 32px;
  height: 32px;

  &:hover {
    cursor: pointer;
    color: ${colors.lagoon};
  }
`;

export const SubIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  top: -4px;
  right: -4px;

  min-width: 18px;
  height: 18px;
  max-width: fit-content;
  border-radius: 4px;
  background: ${colors.tomato};
  border: 1px solid ${colors.tomato};

  font-size: 12px;
  color: ${colors.light};
`;

export const MenuWrap = styled.div`
  position: relative;
`;

export const LinksMenu = styled.div`
  display: flex;
  flex-direction: column;

  position: absolute;
  top: 40px;
  right: 0;

  border-radius: 12px;
  background-color: ${colors.light};
  border: 1px solid ${colors.gray3};
  padding: 16px 0;

  gap: 8px;

  z-index: 9;

  & > * {
    padding: 2px 8px;
  }
`;

export const Mobile = styled.div`
  display: none;
  justify-content: space-between;

  width: 100%;

  @media (max-width: ${breakpoints.laptop}) {
    display: flex;
  }
`;

export const IconWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 32px;
  height: 32px;

  cursor: pointer;
  color: ${colors.lagoon};

  & > svg {
    width: 28px;
    height: 28px;
  }

  &:hover {
    opacity: 0.8;
  }
`;
